import { isNotFoundError } from "../errors/isNotFoundError";

export const removeSigningRequest = async ({
  remove,
  dropRow,
  report,
}: {
  remove: () => Promise<unknown>;
  dropRow: () => void;
  report: (error: unknown) => void;
}) => {
  try {
    await remove();
    dropRow();
  } catch (e) {
    if (isNotFoundError(e)) {
      dropRow();
      return;
    }
    report(e);
  }
};
